export default function React_useRef() {
  return (
    <div>
      <h1>React_useRef Component</h1>
      <p>This is the React_useRef tutorial page.</p>
    </div>
  );
}
